import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from '@hookform/error-message';

import styles from './ErrorMessages.module.scss';

const ErrorMessages = ({ name, errors }) => {
	return (
		<ErrorMessage
			errors={errors}
			name={name}
			render={({ messages }) =>
				messages && Object.entries(messages).map(([type, message]) => <p className={styles.errorText} key={type}>{message}</p>)
			}
		/>
	);
};

ErrorMessages.propTypes = {
	name: PropTypes.string.isRequired,
	errors: PropTypes.object.isRequired,
};

export default ErrorMessages;
